import { Box, Typography, Button } from '@mui/material'
import { ReactNode } from 'react'

export let EmptyState = ({
  icon,
  title,
  description,
  actionText,
  onAction,
}: {
  icon?: ReactNode
  title: string
  description: string
  actionText?: string
  onAction?: () => void
}) => (
  <Box
    sx={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      textAlign: 'center',
      py: 8,
      px: 4,
      mx: 'auto',
      maxWidth: 600,
      minHeight: '50vh',
    }}
  >
    {icon && (
      <Box
        sx={{
          mb: 3,
          opacity: 0.6,
          '& svg': {
            fontSize: 80,
            color: 'rgba(255,255,255,0.4)',
          },
        }}
      >
        {icon}
      </Box>
    )}

    <Typography
      variant="h4"
      sx={{
        mb: 2,
        fontWeight: 300,
        color: 'white',
        fontSize: {
          xs: '1.5rem',
          sm: '2rem',
        },
      }}
    >
      {title}
    </Typography>

    <Typography
      variant="body1"
      sx={{
        mb: 4,
        lineHeight: 1.6,
        color: 'rgba(255,255,255,0.7)',
        fontSize: {
          xs: '1rem',
          sm: '1.125rem',
        },
      }}
    >
      {description}
    </Typography>

    {actionText && onAction && (
      <Button
        variant="outlined"
        color="secondary"
        onClick={onAction}
        sx={{
          px: 4,
          py: 1.5,
          borderColor: 'rgba(255,255,255,0.3)',
          color: 'white',
          '&:hover': {
            borderColor: 'rgba(255,255,255,0.5)',
            backgroundColor: 'rgba(255,255,255,0.05)',
          },
        }}
      >
        {actionText}
      </Button>
    )}
  </Box>
)
